import { Injectable } from '@angular/core';
import {CrudBaseService} from "./crud-base.service";
import {Cid10Model, Cid10PrimaryKey} from "../models/cid10.model";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class Cid10Service extends CrudBaseService<Cid10Model> {

    constructor(httpClient: HttpClient) {
      super(httpClient, 'cid-10');
    }

  public getPk(id: Cid10PrimaryKey): Cid10PrimaryKey {
    return Object.assign(new Cid10PrimaryKey(), id);
  }

  public getByCid10(cid10: string) {
    return this.getAllByUrlQuery<Cid10Model>(`codigo-cid/${cid10}`);
  }
}
